import styled from "styled-components";

// TEXT

// STYLES
export const Wrapper = styled.div`
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
  padding: 0 1.5rem;
`;

// DATA

// TYPES
export interface Props {
  title: string;
  className?: string;
  description?: string;
  descriptionVariant?: "normal" | "subtle";
}

// CONSTANTS

// FUNCTIONS

// ASSETS
